import React from "react";
import "./Home.css";
import Product from "./Product";

const Home = () => {
  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__image"
          src="https://m.media-amazon.com/images/I/71BG3nzP5KL._SX3000_.jpg"
          alt="amazon ad"
        ></img>
      </div>

      <div className="home__row">
        <Product
          id="12321341"
          title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
          price={29.99}
          image="https://images-na.ssl-images-amazon.com/images/I/81-QB7nDh4L.jpg"
          rating={5}
        />
        <Product
          id="49538094"
          title="Kenwood Mix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass Bowl"
          price={239.0}
          image="https://m.media-amazon.com/images/I/41KfKQhVLCL._AC_.jpg"
          rating={4}
        />
      </div>

      <div className="home__row">
        <Product
          id="4903850"
          title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
          price={199.99}
          image="https://m.media-amazon.com/images/I/71916r38cNL._AC_SX679_.jpg"
          rating={3}
        />
        <Product
          id="23445930"
          title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
          price={98.99}
          image="https://m.media-amazon.com/images/I/61OHtxR+daL._AC_SX425_.jpg"
          rating={5}
        />
        <Product
          id="3254354345"
          title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)"
          price={239.0}
          image="https://m.media-amazon.com/images/I/81MF389-9gS._AC_SL1500_.jpg"
          rating={4}
        />
      </div>

      <div className="home__row">
        <Product
          id="90829332"
          title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440"
          price={1094.98}
          image="https://m.media-amazon.com/images/I/81rus0UFhsL._AC_SX450_.jpg"
          rating={4}
        />
      </div>
    </div>
  );
};

export default Home;
